<template>

    <b-row>
      <b-col cols="12">

        <!-- PERMISSION TABLE -->
        <b-card no-body class="border">

          <b-card-header class="p-1">
            <b-card-title class="font-medium-2">
              <feather-icon icon="LockIcon" size="18"/>
              <span class="align-middle ml-50">{{ $t('Calendars Permission')}}</span>
            </b-card-title>
          </b-card-header>

          <div class="m-2">

            <!-- Table Top -->
            <b-row>
              <!-- Per Page -->
              <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <label>{{ $t('Show') }}</label>
                <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="perPageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block mx-50"
                />
                <label>{{ $t('entries') }}</label>
              </b-col>

              <!-- Search -->
              <b-col cols="12" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search')"/>
                </div>
              </b-col>
            </b-row>

          </div>
          <b-table striped responsive class="mb-0"
                   :items="authCalendars" :fields="fields">
            <template #head(list)="data">
              <b-form-checkbox @change="checkAll(data, $event)" />
            </template>

            <template #cell(name)="data">
              {{ data.value }}
            </template>

            <template #cell()="data">
              <b-form-checkbox :state="userCalendars.includes(data.item.id) ? true : null" :checked="requestIds.includes(data.item.id)" @change="change(data, $event)" />
            </template>

          </b-table>

          <div class="mx-2 mb-2">
            <b-row>

              <b-col cols="12" sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-muted">
                  {{ $t('Showing') }} {{ dataMeta.from }} {{$t('to')}} {{ dataMeta.to }} {{ $t('of')}} {{ dataMeta.of }} {{$t('entries-calendars')}}
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalTable"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                    />
                  </template>
                </b-pagination>

              </b-col>

            </b-row>
          </div>
        </b-card>
      </b-col>


      <b-col cols="12">
        <!-- Action Buttons -->
        <b-button
            type="submit"
            variant="primary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="submit"
        >
         {{ $t('Save Changes')}}
        </b-button>
      </b-col>


    </b-row>
</template>

<script>
import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,    BPagination,
  BMediaAside,
  BMediaBody,
  BLink,BBadge,
  BImg,
  BTable, BFormCheckbox, BCardTitle, BCardHeader,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref, computed, watch } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import permissionsStoreModule from '@/views/modules/user/users-edit/permissions/permissionsStoreModule'
import usePermissions from '@/views/modules/user/users-edit/permissions/usePermissions'
import DevicesFilter from '@/views/modules/user/users-edit/permissions/DevicesFilter'

export default {
  components: {
    BButton, BForm, BImg, BFormFile,
    BFormGroup, BFormInput, BRow,
    BCol, BAlert, BCard, BCardText,BBadge,
    BMedia, BMediaAside, BMediaBody, vSelect,BPagination,
    BLink,BTable,BFormCheckbox,  BCardTitle, BCardHeader, DevicesFilter
  },
  directives: {
    Ripple,
  },
  props: {
    user: {
      type: Number,
      required: true
    },
  },

  setup(props, { root, emit }) {

    const authCalendars = ref([])
    const userCalendars = ref([])


    const {perPage, perPageOptions, searchQuery, currentPage, totalTable, dataMeta } = usePermissions()

    const filter = ref({})

    watch([currentPage, perPage, searchQuery], () => {
      filter.value = {
        ...(searchQuery.value && {q: searchQuery.value}),
      }

      fetchAuthCalendars()
    })


    const CALENDARS_PERMISSION_APP_STORE_MODULE_NAME = 'app-permission'

    if (!store.hasModule(CALENDARS_PERMISSION_APP_STORE_MODULE_NAME))
            store.registerModule(CALENDARS_PERMISSION_APP_STORE_MODULE_NAME,
                permissionsStoreModule)

    emit('requestIncrement',1)


    const fetchAuthCalendars = () => {
      emit('requestIncrement',1)
      store.dispatch('app-permission/authCalendars', {
        length: perPage.value,
        page: currentPage.value,
        ...filter.value
      })
      .then(response => {
          emit('requestDecrement',1)
          authCalendars.value = response.data.data
          const { total } = response.data.meta
          totalTable.value = total

        })
      .catch(res => {})
    }

    fetchAuthCalendars()

    store.dispatch('app-permission/userCalendars', { id: props.user })
        .then(res => {
          emit('requestDecrement',1)
          requestIds.value = res.data.data.map(a => a.id)
          userCalendars.value = res.data.data.map(a => a.id)
        })
        .catch(res => {})


    const  fields = ['name','list']


    const submit = () => {
      emit('requestIncrement',1)
      store.dispatch('app-permission/attachCalendarsToUser', {
        id: props.user,
        data: requestIds.value
      }).then(res => {

        emit('requestDecrement',1)
        toaster('Calendars Attached Successfully',
          'success','success')
        changedIds.value = []

        if (res.data.attached) {
          userCalendars.value.push(...res.data.attached)
        }

        if (res.data.detached) {
          for (let i in res.data.detached) {
            const index = userCalendars.value.indexOf(
                res.data.detached[i]
            )

            userCalendars.value.splice(
                userCalendars.value.indexOf(
                    res.data.detached[i]
                ), 1)
          }
        }


      }).catch(reason => {
        emit('requestDecrement',1)
        toaster('Error Happened',
            'error','Error')
      })
    }

    const requestIds = ref([])
    const changedIds = ref([])


    const change = (data, value) => {
      const index = requestIds.value.indexOf(data.item.id);
      if (value && index === -1) requestIds.value.push(data.item.id)
      else requestIds.value.splice(index, 1)
    }

    const checkAll = (data, value) => {
      if (value) requestIds.value = authCalendars.value.map((v) => v.id)
      else requestIds.value = []
    }


    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }

    return {
      authCalendars,
      userCalendars,
      perPage,
      perPageOptions,
      currentPage,
      searchQuery,
      totalTable,
      dataMeta,
      change,
      checkAll,
      fields,
      submit,
      fetchAuthCalendars,
      requestIds,
    }
  },
}
</script>
